var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIcon)?_c('b-tooltip',{attrs:{"label":_vm.tooltipLabel,"position":"is-bottom"}},[_c('b-icon',{attrs:{"icon":"alert","type":_vm.iconType,"size":_vm.size}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }